/**
 * @class EducationalVideosStringAssets A collection of string assets that pertain to educational videos
 */
export class EducationalVideosStringAssets {
   // video catalogs
   static educationalVideosBaseRoute: string = 'educationalVideos'; // the primary URL route for the educationalVideos
   static mainCatalogId: string = 'MainCatalog'; // Id of the Main catalog of educational videos
   static channelsCatalogId: string = 'WorkingWithChannelsCatalog'; // Id of the Channels catalog of educational videos
   static categoriesCatalogId: string = 'WorkingWithCategoriesCatalog'; // Id of the Categories catalog of educational videos
   static gettingStartedCatalogId: string = 'GettingStartedCatalog'; // Id of the Getting Started catalog of educational videos
   static signInPageCatalogId: string = 'SignInPageCatalog'; // Id of the Sign-in Page catalog of educational videos
   static topicsCatalogId: string = 'WorkingWithTopicsCatalog'; // Id of the Topics catalog of educational videos
   static topicItemsCatalogId: string = 'WorkingWithTopicItemsCatalog'; // Id of the Topic Items catalog of educational videos
   static digitalMediaCatalogId: string = 'DigitalMediaCatalog'; // Id of the Digital Media catalog of educational videos

   // individual videos
   static myDigiBrainOverviewVideoId: string = 'MyDigiBrainOverview'; // Id of the "MyDigiBrain Intro & Overview" educational video
   static createAUserAccountId: string = 'CreatingAUserAccount'; // Id of the "Creating a User Account" educational video
}